<template>
  <WsMain>
    <WsCrud
      :modelName="$store.state.model[modelName].modelName"
      label="我的一日宅宅"
      :fields="$store.state.model[modelName].fields"
      :liveSearching="true"
      :showFields="showFields"
      :fetchQuery="_fetchQuery"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :updatable="false"
      :createHideFields="createHideFields"
      :createDefaultValues="_createDefaultValues"
      :infiniteScroll="true"
    ></WsCrud>
  </WsMain>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "我的一日宅宅",
    };
  },
  
  data: () => ({
    createHideFields: ["status", "wasa"],
    modelName: "work_from_home",
    showFields: ["id", "date", "status"],
  }),

  computed: {
    _createDefaultValues() {
      return {
        wasa: this._currentUser.id,
      };
    },
    _fetchQuery() {
      return {
        wasa: this._currentUser.id,
      };
    },
    _currentUser() {
      return this.$store.state.auth.currentUser;
    },
  },
};
</script>